<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
            <h2>Tasks Catalog</h2>
          </div>
          <div class="button-items mt-3 mb-3" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadTaskData(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all filters and sorting" appActionTooltip>Clear <i class="mdi mdi-filter-remove"></i></button>
          </div>
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadTaskData($event)" [value]="tasks" dataKey="id" styleClass="p-datatable-tasks" [rowHover]="true"
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
        <ng-template pTemplate="header" let-columns paginatorDropdownAppendTo="body">
          <tr>
            <th style="width:6rem">
              View/Edit
            </th>
            <th pSortableColumn="taskName">
              <div class="flex justify-content-between align-items-center">
                Task Name
                <p-sortIcon field="taskName"></p-sortIcon>
                <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="taskName"
                display="menu" ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="taskFullName">
              <div class="flex justify-content-between align-items-center">
                Task Full Name
                <p-sortIcon field="taskFullName"></p-sortIcon>
                <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="taskFullName"
                display="menu" ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="taskTypeCode">
              <div class="flex justify-content-between align-items-center">
                Task Type
                <p-sortIcon field="taskTypeCode"></p-sortIcon>
                <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="taskTypeCode"
                display="menu" ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="qbTaskId">
              <div class="flex justify-content-between align-items-center">
                QuickBook Id
                <p-sortIcon field="qbTaskId"></p-sortIcon>
                <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="qbTaskId"
                display="menu" ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="qbDescription">
              <div class="flex justify-content-between align-items-center">
                Description
                <p-sortIcon field="qbDescription"></p-sortIcon>
                <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                  [matchModeOptions]="matchModeOptions" type="text" field="qbDescription"
                display="menu" ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="disbursementRelated">
              <div class="flex justify-content-between align-items-center">
                Disbursement Related
                <p-sortIcon field="disbursementRelated"></p-sortIcon>
                <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                  type="text" field="disbursementRelated"
                  [showClearButton]="true" [showApplyButton]="true" [showMatchModes]="false"
                  display="menu" >
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [ngModel]="value" [options]="readyStateList"
                      (onChange)="filter($event.value)" placeholder="Any">
                      <ng-template let-option pTemplate="item">
                        <span
                        [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </ng-template></p-columnFilter>
                </div>
              </th>



              <th pSortableColumn="descriptionTypeCode">
                <div class="flex justify-content-between align-items-center">
                  Description Type
                  <p-sortIcon field="descriptionTypeCode"></p-sortIcon>
                  <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                    [showMatchModes]="false"
                    [showOperator]="false"
                    [showAddButton]="false"
                    [showClearButton]="true"
                    [showApplyButton]="true" type="text" field="descriptionTypeCode"
                    display="menu" >
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="descriptionTypesList"
                        (onChange)="filter($event.value)" placeholder="Any">
                        <ng-template let-option pTemplate="item">
                          <span
                          [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </ng-template></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="rate">
                  <div class="flex justify-content-between align-items-center">
                    Rate
                    <p-sortIcon field="rate"></p-sortIcon>
                    <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                    type="numeric" field="rate" display="menu" ></p-columnFilter>
                  </div>
                </th>

                <th pSortableColumn="rateTypeCode">
                  <div class="flex justify-content-between align-items-center">
                    Rate Type
                    <p-sortIcon field="rateTypeCode"></p-sortIcon>
                    <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                      [showMatchModes]="false" [showClearButton]="true" [showApplyButton]="true" type="text" field="rateTypeCode"
                      display="menu" >
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown [ngModel]="value" [options]="rateTypesList"
                          (onChange)="filter($event.value)" placeholder="Any">
                          <ng-template let-option pTemplate="item">
                            <span
                            [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                          </ng-template>
                        </p-dropdown>
                      </ng-template></p-columnFilter>
                    </div>
                  </th>
                  <th pSortableColumn="timeEstimate">
                    <div class="flex justify-content-between align-items-center">
                      Time Estimate(HH:MM)
                      <p-sortIcon field="timeEstimate"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="taskClass">
                    <div class="flex justify-content-between align-items-center">
                      Class
                      <p-sortIcon field="taskClass"></p-sortIcon>
                      <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                        [matchModeOptions]="matchModeOptions" type="text" field="taskClass"
                      display="menu" ></p-columnFilter>
                    </div>
                  </th>
                  <th pSortableColumn="billable">
                    <div class="flex justify-content-between align-items-center">
                      Billable
                      <p-sortIcon field="billable"></p-sortIcon>
                      <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                        [showMatchModes]="false" type="text" field="billable" [showClearButton]="true" [showApplyButton]="true"
                        display="menu" >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="billableList"
                            (onChange)="filter($event.value)" placeholder="Any">
                            <ng-template let-option pTemplate="item">
                              <span
                              [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                            </ng-template>
                          </p-dropdown>
                        </ng-template></p-columnFilter>
                      </div>
                    </th>
                    <th pSortableColumn="reqEstimate">
                      <div class="flex justify-content-between align-items-center">
                        Request Estimate
                        <p-sortIcon field="reqEstimate"></p-sortIcon>
                        <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                          [showMatchModes]="false" [showClearButton]="true" [showApplyButton]="true" type="text" field="reqEstimate"
                          display="menu" >
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [ngModel]="value" [options]="reqEstimateList"
                              (onChange)="filter($event.value)" placeholder="Any">
                              <ng-template let-option pTemplate="item">
                                <span
                                [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                              </ng-template>
                            </p-dropdown>
                          </ng-template></p-columnFilter>
                        </div>
                      </th>
                      <th pSortableColumn="practiceAreaCode">
                        <div class="flex justify-content-between align-items-center">
                          Practice Area Code
                          <p-sortIcon field="practiceAreaCode"></p-sortIcon>
                          <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                            [matchModeOptions]="matchModeOptions" type="text" field="practiceAreaCode"
                          display="menu" ></p-columnFilter>
                        </div>
                      </th>
                      <th pSortableColumn="stateRelated">
                        <div class="flex justify-content-between align-items-center">
                          State Related
                          <p-sortIcon field="stateRelated"></p-sortIcon>
                          <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                            [showMatchModes]="false" type="text" field="stateRelated" [showClearButton]="true" [showApplyButton]="true"
                            display="menu" >
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                              <p-dropdown [ngModel]="value" [options]="stateRelatedList"
                                (onChange)="filter($event.value)" placeholder="Any">
                                <ng-template let-option pTemplate="item">
                                  <span
                                  [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                                </ng-template>
                              </p-dropdown>
                            </ng-template></p-columnFilter>
                          </div>
                        </th>
                        <th pSortableColumn="readyStatus">
                          <div class="flex justify-content-between align-items-center">
                            Ready Status
                            <p-sortIcon field="readyStatus"></p-sortIcon>
                            <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                              [showMatchModes]="false" type="text" field="readyStatus" [showClearButton]="true" [showApplyButton]="true"
                              display="menu" >
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [ngModel]="value" [options]="readyStateList"
                                  (onChange)="filter($event.value)" placeholder="Any">
                                  <ng-template let-option pTemplate="item">
                                    <span
                                    [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                                  </ng-template>
                                </p-dropdown>
                              </ng-template></p-columnFilter>
                            </div>
                          </th>
                          <th pSortableColumn="entityRelated">
                            <div class="flex justify-content-between align-items-center">
                              Entity Related
                              <p-sortIcon field="entityRelated"></p-sortIcon>
                              <p-columnFilter  [showOperator]="false" [showAddButton]="false" matchMode="equals"
                                [showMatchModes]="false" type="text" field="entityRelated" [showClearButton]="true" [showApplyButton]="true"
                                display="menu" >
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <p-dropdown [ngModel]="value" [options]="readyStateList"
                                    (onChange)="filter($event.value)" placeholder="Any">
                                    <ng-template let-option pTemplate="item">
                                      <span
                                      [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                                    </ng-template>
                                  </p-dropdown>
                                </ng-template></p-columnFilter>
                              </div>
                            </th>
                          </tr>

                        </ng-template>
                        <ng-template pTemplate="body" let-tasks let-columns="columns">
                          <tr>
                            <td >
                              <div class="flex justify-content-between align-items-center">
                                <a class="btn btn-info btn-sm" pTooltip="View task details" appActionTooltip (click)="viewTask(tasks)" role="button"><i class="
                                mdi mdi-eye"></i></a>
                                <a class="btn btn-warning btn-sm" pTooltip="Edit task" appActionTooltip (click)="editTask(tasks)" role="button"><i
                                class="mdi mdi-pencil"></i></a>
                              </div>
                            </td>
                            @for (col of columns; track col) {
                              <td>
                                {{tasks[col.field]}}
                              </td>
                            }
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td [attr.colspan]="4">
                              No records found
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>

                <p-dialog [resizable]="false" [draggable]="false" [(visible)]="taskCatDialog" (onHide)="closeDialog()" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
                  <ng-template pTemplate="content">
                    <app-notification [errorMsg]="errorMsg"></app-notification>
                    <form [formGroup]="taskForm">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            @for (field of [
                              {label: 'Task Name', control: 'taskName', type: 'text', disabled: true},
                              {label: 'QuickBook Id', control: 'qbTaskId', type: 'text', disabled: true},
                              {label: 'Description', control: 'qbDescription', type: 'text', disabled: true},
                              {label: 'Class', control: 'taskClass', type: 'text', disabled: true},
                              {label: 'Ready Status', control: 'readyStatus', type: 'text', disabled: true},
                              {label: 'Project Only', control: 'projectOnly', type: 'text', disabled: true}
                              ]; track field) {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label [for]="field.control + 'ID'" class="form-label">{{field.label}}</label>
                                  <input class="form-control"  readonly [type]="field.type" [id]="field.control + 'ID'" [formControlName]="field.control">
                                </div>
                              </div>
                            }
                            <div class="col-xl-3" >
                              <div class="mb-3">
                                <label for="rateId" class="form-label">Rate</label><span style="color:var(--al-danger);">*</span>
                                <input class="form-control" type="text"  formControlName="rate" id="rateId">
                                @if (submitted && rate && rate.invalid) {
                                  <span style="color:var(--al-danger)">Rate is required</span>
                                }
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Task Type</label>
                                <select class="form-select" formControlName="taskTypeCode"><span style="color:var(--al-danger);">*</span>
                                <option value="" selected>Select</option>
                                @for (value of practiceAreaCodes; track value) {
                                  <option [ngValue]="value.description" [selected]="value.description == taskForm.getRawValue().taskTypeCode">{{value.description}}</option>
                                }
                              </select>
                              @if (submitted && taskTypeCode && taskTypeCode.invalid) {
                                <span style="color:var(--al-danger)">Type is required</span>
                              }
                            </div>
                          </div>
                          <!-- Disbursements Section -->
                          @if (taskForm.getRawValue().taskTypeCode === 'Disbursements') {
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label for="rateTypeCodeID" class="form-label">Rate Type <span style="color:var(--al-danger);">*</span></label>
                                <select class="form-select" formControlName="rateTypeCode" (change)="onRateTypeChange()">
                                  <option value="" selected>Select</option>
                                  @for (value of rateTypes; track value) {
                                    <option [ngValue]="value">{{value}}</option>
                                  }
                                </select>
                                @if (submitted && rateTypeCode && rateTypeCode.invalid) {
                                  <span style="color:var(--al-danger)">Rate Type is required</span>
                                }
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label for="descriptionTypeCodeId" class="form-label">Description Type <span style="color:var(--al-danger);">*</span></label>
                                <select class="form-select" formControlName="descriptionTypeCode">
                                  <option value="" selected>Select</option>
                                  @for (value of descriptionTypes; track value) {
                                    <option [ngValue]="value">{{value}}</option>
                                  }
                                </select>
                                @if (submitted && descriptionTypeCode && descriptionTypeCode.invalid) {
                                  <span style="color:var(--al-danger)">Description Type is required</span>
                                }
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Billable <span style="color:var(--al-danger);">*</span></label>
                                <select class="form-select" formControlName="billable">
                                  <option value="" selected>Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                                @if (submitted && billable && billable.invalid) {
                                  <span style="color:var(--al-danger)">Billable is required</span>
                                }
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Practice Area Code <span style="color:var(--al-danger);">*</span></label>
                                <select class="form-select" formControlName="practiceAreaCode">
                                  <option value="" selected>Select</option>
                                  @for (value of practiceAreaCodes; track value) {
                                    <option [ngValue]="value.description">{{value.description}}</option>
                                  }
                                </select>
                                @if (submitted && practiceAreaCode && practiceAreaCode.invalid) {
                                  <span style="color:var(--al-danger)">Practice Area Code is required</span>
                                }
                              </div>
                            </div>
                            <!-- Time Records Section -->
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Time Records</label>
                                <select class="form-select" formControlName="timeRecords">
                                  <option value="" selected>Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label for="disbursementTaskType" class="form-label">Disbursement Task GL Code <span style="color:var(--al-danger);">*</span></label>
                                <select class="form-select" formControlName="disbursementTaskType" appendTo="body">
                                  <option value="" selected>Select</option>
                                  @for (value of disbursementTaskTypes; track value) {
                                    <option [ngValue]="value.id">{{value.name}}</option>
                                  }
                                </select>
                                @if (submitted && disbursementTaskType && disbursementTaskType.invalid) {
                                  <span style="color:var(--al-danger)">Disbursement Task GL Code is required</span>
                                }
                              </div>
                            </div>
                          } @else {
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Disbursement Related</label><span style="color:var(--al-danger);">*</span>
                                <select class="form-select" formControlName="disbursementRelated">
                                  <option value="" selected>Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div class="mb-3">
                                <label class="form-label">Disbursement Tasks <span style="color:var(--al-danger);">*</span></label>
                                <p-multiSelect [maxSelectedLabels]="10000"
                                  [options]="disbursementTaskOptions"
                                  formControlName="disbursementAssociatedTasks"
                                  [filter]="true"
                                  [showToggleAll]="true"
                                  [optionLabel]="'label'"
                                  [optionValue]="'value'"
                                  placeholder="Select"
                                  [appendTo]="'body'"
                                  [emptyFilterMessage]="'No data found'"
                                  [emptyMessage]="'No data found'"
                                ></p-multiSelect>
                                @if (submitted && disbursementAssociatedTasks && disbursementAssociatedTasks.invalid) {
                                  <span style="color:var(--al-danger)">Disbursement Tasks is required</span>
                                }
                              </div>
                            </div>
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="rateTypeCodeID" class="form-label">Rate Type</label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select"  formControlName="rateTypeCode" (change)="onRateTypeChange()">
                                    <option value="" selected>Select</option>
                                    @for (value of rateTypes; track value) {
                                      <option [ngValue]="value" [selected]="value == taskForm.getRawValue().rateTypeCode">{{value}}</option>
                                    }
                                  </select>
                                  @if (submitted && rateTypeCode && rateTypeCode.invalid) {
                                    <span style="color:var(--al-danger)">Rate Type is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="descriptionTypeCodeId" class="form-label">Description Type</label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select" formControlName="descriptionTypeCode">
                                    <option value="" selected>Select</option>
                                    @for (value of descriptionTypes; track value) {
                                      <option [ngValue]="value" [selected]="value == taskForm.getRawValue().descriptionTypeCode">{{value}}</option>
                                    }
                                  </select>
                                  @if (submitted && descriptionTypeCode && descriptionTypeCode.invalid) {
                                    <span style="color:var(--al-danger)">Description Type is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="timeRangeMinID" class="form-label">Time Range Minimum</label><span style="color:var(--al-danger);">*</span>
                                  <p-calendar appendTo="body" [showTime]="true"  hourFormat="24" [timeOnly]="true" formControlName="timeRangeMin" [defaultDate]="defaultTime"></p-calendar>
                                  @if (submitted && timeRangeMin && timeRangeMin.invalid) {
                                    <span style="color:var(--al-danger)">Time Range Minimum is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="timeRangeMaxID" class="form-label">Time Range Maximum</label><span style="color:var(--al-danger);">*</span>
                                  <p-calendar appendTo="body" [showTime]="true"  hourFormat="24" [timeOnly]="true" formControlName="timeRangeMax" [defaultDate]="defaultTime"></p-calendar>
                                  @if (submitted && timeRangeMax && timeRangeMax.invalid) {
                                    <span style="color:var(--al-danger)">Time Range Maximum is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label class="form-label">Enforce Maximum</label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select"  formControlName="enforceMax"  (change)="onEnforceMaxChange()">
                                    <option value="" selected>Select</option>
                                    <option value="Yes" selected>Yes</option>
                                    <option value="No" selected>No</option>
                                  </select>
                                  @if (submitted && enforceMax && enforceMax.invalid) {
                                    <span style="color:var(--al-danger)">Enforce Maximum is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="timeEstimateID" class="form-label">Time Estimate</label><span style="color:var(--al-danger);">*</span>
                                  <p-calendar appendTo="body" [showTime]="true"  hourFormat="24" [timeOnly]="true" formControlName="timeEstimate" [defaultDate]="defaultTime">
                                  </p-calendar>
                                  @if (submitted && timeEstimate && timeEstimate.invalid) {
                                    <span style="color:var(--al-danger)">Time Estimate is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label class="form-label">Billable </label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select"  formControlName="billable">
                                    <option value="" selected>Select</option>
                                    <option value="Yes" selected>Yes</option>
                                    <option value="No" selected>No</option>
                                  </select>
                                  @if (submitted && billable && billable.invalid) {
                                    <span style="color:var(--al-danger)">Billable is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label class="form-label">Practice Area Code</label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select" formControlName="practiceAreaCode">
                                    <option value="" selected>Select</option>
                                    @for (value of practiceAreaCodes; track value) {
                                      <option [ngValue]="value.description" [selected]="value.description == taskForm.getRawValue().practiceAreaCode">{{value.description}}</option>
                                    }
                                  </select>
                                  @if (submitted && practiceAreaCode && practiceAreaCode.invalid) {
                                    <span style="color:var(--al-danger)">Practice Area Code is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label class="form-label">State Related </label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select"  formControlName="stateRelated">
                                    <option value="" selected>Select</option>
                                    <option value="Yes" selected>Yes</option>
                                    <option value="No" selected>No</option>
                                  </select>
                                  @if (submitted && stateRelated && stateRelated.invalid) {
                                    <span style="color:var(--al-danger)">State Related  is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="countryRelated" class="form-label">Country Related </label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select" id="countryRelated"  formControlName="countryRelated">
                                    <option value="" selected>Select</option>
                                    <option value="Yes" selected>Yes</option>
                                    <option value="No" selected>No</option>
                                  </select>
                                  @if (submitted && countryRelated && countryRelated.invalid) {
                                    <span style="color:var(--al-danger)">Country Related  is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="quantityRelated" class="form-label">Quantity Related </label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select" id="quantityRelated"  formControlName="quantityRelated">
                                    <option value="" selected>Select</option>
                                    <option value="Yes" selected>Yes</option>
                                    <option value="No" selected>No</option>
                                  </select>
                                  @if (submitted && quantityRelated && quantityRelated.invalid) {
                                    <span style="color:var(--al-danger)">Quantity Related  is required</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (taskForm.getRawValue().taskTypeCode !== 'Disbursements') {
                              <div class="col-xl-3">
                                <div class="mb-3">
                                  <label for="quantityType" class="form-label">Quantity Type </label>@if (quantityRelated.value!='No') {
                                  <span style="color:var(--al-danger);">*</span>
                                }
                                <select class="form-select" id="quantityType"  formControlName="quantityType">
                                  <option value="" selected>Select</option>
                                  <option value="State" selected>State</option>
                                  <option value="Number" selected>Number</option>
                                </select>
                                @if (submitted && quantityType && quantityType.invalid) {
                                  <span style="color:var(--al-danger)">Quantity Type is required</span>
                                }
                              </div>
                            </div>
                          }
                          <div class="col-xl-3">
                            <div class="mb-3">
                              <label class="form-label">Time Records</label>
                              <select class="form-select" formControlName="timeRecords">
                                <option value="" selected>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        }
                        <!-- Non-Disbursements Section -->
                        <div class="col-xl-3">
                          <div class="mb-3">
                            <label class="form-label">Non Billable Reason</label>
                            @if (billable.value=='No') {
                              <span style="color:var(--al-danger);">*</span>
                            }
                            <p-dropdown  formControlName="nonBillableReason"
                                    [options]="[
                                        {label: 'Pre-Invoiced', value: 'Pre-Invoiced'},
                                        {label: 'Managed Service Project', value: 'Managed Service Project'},
                                        {label: 'Internal or Administrative Task', value: 'Internal or Administrative Task'},
                                        {label: 'Error Correction', value: 'Error Correction'},
                                        {label: 'Client Courtesy', value: 'Client Courtesy'},
                                        {label: 'Business Development', value: 'Business Development'},
                                        {label: 'Knowledge Management', value: 'Knowledge Management'},
                                        {label: 'Professional Development', value: 'Professional Development'},
                                        {label: 'Marketing and Thought Leadership', value: 'Marketing and Thought Leadership'},
                                        {label: 'Fixed Fee Project', value: 'Fixed Fee Project'}
                                    ]"
                              appendTo="body"
                              optionLabel="label"
                              optionValue="value"
                              [showClear]="true"
                              [filter]="true"
                              [style]="{'width':'100%'}"
                              placeholder="Select Non Billable Reason">
                            </p-dropdown>
                            @if (submitted && nonBillableReason && nonBillableReason.invalid) {
                              <span style="color:var(--al-danger)">Non Billable Reason is required</span>
                            }
                          </div>
                        </div>

                        <!-- Entity Related -->
                        <div class="col-xl-3">
                          <div class="mb-3">
                            <label for="entityRelated" class="form-label">Entity Related</label>
                            <select class="form-select" id="entityRelated" formControlName="entityRelated">
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>

                        <!-- Task Instructions -->
                        <div class="col-xl-12">
                          <div class="mb-3">
                            <label for="taskInstructions" class="form-label fw-bold">Task Instructions</label>
                            <small class="d-block text-muted mb-2">
                              <i class="mdi mdi-information-outline"></i>
                              Provide step-by-step instructions for completing this task. Supports rich text formatting, links, and bullet points. Max 10000 characters.
                            </small>

                            <p-editor
                              formControlName="taskInstructions"
                              [style]="{ height: '320px' }"
                              [readonly]="viewOnly">
                              <ng-template pTemplate="header">
                                <span class="ql-formats">
                                  <button type="button" class="ql-bold" aria-label="Bold" pTooltip="Bold" appActionTooltip></button>
                                  <button type="button" class="ql-italic" aria-label="Italic" pTooltip="Italic" appActionTooltip></button>
                                  <button type="button" class="ql-underline" aria-label="Underline" pTooltip="Underline" appActionTooltip></button>
                                </span>
                                <span class="ql-formats">
                                  <button type="button" class="ql-list" value="ordered" aria-label="Ordered List" pTooltip="Numbered list" appActionTooltip></button>
                                  <button type="button" class="ql-list" value="bullet" aria-label="Unordered List" pTooltip="Bulleted list" appActionTooltip></button>
                                </span>
                                <span class="ql-formats">
                                  <button type="button" class="ql-link" aria-label="Insert Link" pTooltip="Insert link" appActionTooltip></button>
                                </span>
                                <span class="ql-formats">
                                  <button type="button" class="ql-clean" aria-label="Remove Styles" pTooltip="Clear formatting" appActionTooltip></button>
                                </span>
                              </ng-template>
                            </p-editor>

                            <small class="text-muted d-block mt-2">
                              <i class="mdi mdi-text-box-outline"></i>
                              Characters: <strong>{{ getTaskInstructionsTextLength() }}</strong> / 10000
                            </small>

                            @if (submitted && taskInstructions && taskInstructions.invalid) {
                              <div class="text-danger mt-1">
                                <small>Task Instructions cannot exceed 10000 characters</small>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (!viewOnly) {
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="button-items" style="float: right;">
                          @if (newTask) {
                            <a class="btn btn-primary"  (click)="saveTask()" pTooltip="Save task" appActionTooltip> Save @if (btnLoading) {
                              <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                            }</a>
                          }
                          @if (!newTask) {
                            <a class="btn btn-primary"  (click)="saveTask()" pTooltip="Update task" appActionTooltip> Update @if (btnLoading) {
                              <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                            }</a>
                          }
                          <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Cancel without saving" appActionTooltip> Cancel </a>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </ng-template>

            </p-dialog>
